import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { connect } from 'react-redux'
import * as auth from '../_redux/authRedux'
import { login, MFA_PENDING_KEY } from '../_redux/authCrud'
import MfaChallenge from './MfaChallenge'
import { apiMessage } from '../../../service/apiError'


/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: '',
  password: ''
}

function Login(props) {
  const [loading, setLoading] = useState(false)
  const [mfa, setMfa] = useState(null)
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email('รูปแบบอีเมลไม่ถูกต้อง')
      .max(50, 'อีเมลต้องไม่เกิน 50 ตัวอักษร')
      .required('กรุณากรอกอีเมล'),
    password: Yup.string()
      .min(3, 'รหัสผ่านต้องมีอย่างน้อย 3 ตัวอักษร')
      .max(50, 'รหัสผ่านต้องไม่เกิน 50 ตัวอักษร')
      .required('กรุณากรอกรหัสผ่าน')
  })

  const enableLoading = () => {
    setLoading(true)
  }

  const disableLoading = () => {
    setLoading(false)
  }

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }

    return ''
  }

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading()
      setTimeout(() => {
        login(values.email.trim(), values.password)
          .then(({ data: { data } }) => {
            if (data && data.mfaRequired && data.mfaPendingToken) {
              sessionStorage.setItem(MFA_PENDING_KEY, data.mfaPendingToken)
              setMfa({ enrolled: Boolean(data.mfaEnrolled) })
              disableLoading()
              setSubmitting(false)
              return
            }
            if (!data || !data.accessToken) {
              disableLoading()
              setSubmitting(false)
              setStatus('อีเมลหรือรหัสผ่านไม่ถูกต้อง')
              return
            }
            localStorage.setItem("Token", data.accessToken)
            if (data.accessTokenPrivilege) {
              localStorage.setItem("accessTokenPrivilege", data.accessTokenPrivilege)
            }
            disableLoading()
            props.login(data.accessToken)
          })
          .catch((err) => {
            disableLoading()
            setSubmitting(false)
            setStatus(apiMessage(err, 'อีเมลหรือรหัสผ่านไม่ถูกต้อง'))
          })
      }, 1000)
    }
  })

  if (mfa) {
    return (
      <MfaChallenge
        enrolled={mfa.enrolled}
        onCancel={() => {
          sessionStorage.removeItem(MFA_PENDING_KEY)
          setMfa(null)
          formik.resetForm()
        }}
        onComplete={(data) => {
          if (data.accessTokenPrivilege) {
            localStorage.setItem('accessTokenPrivilege', data.accessTokenPrivilege)
          }
          localStorage.setItem('Token', data.accessToken)
          props.login(data.accessToken)
        }}
      />
    )
  }

  const submitDisabled =
    formik.isSubmitting || loading || !formik.values.email || !formik.values.password

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">ลงชื่อเข้าใช้</h3>
        <p className="text-dark-75">
          กรอกอีเมลและรหัสผ่านของคุณ
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : null}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="อีเมล"
            type="email"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'email'
            )}`}
            name="email"
            {...formik.getFieldProps('email')}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.email}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="รหัสผ่าน"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'password'
            )}`}
            name="password"
            {...formik.getFieldProps('password')}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          {/* <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            ลืมรหัสผ่าน
          </Link> */}
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={submitDisabled}
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            style={{ cursor: submitDisabled ? 'not-allowed' : 'pointer' }}
          >
            <span>เข้าสู่ระบบ</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  )
}

export default connect(null, auth.actions)(Login)
